import * as ActionTypes from "../ActionTypes";

const initialState = {
    isLoading: true,
    isSuccess: false,
    isError: false,
    earning_data: [],
    deduction_data:[],
    isEarningsLoading: false,
    isDeductionLoading: false,
    custom_earning_data: [],
    custom_deduction_data:[],
}

export const ComponentReducer = function (state = initialState, action) {
    switch (action.type) {
        case ActionTypes.PAYROLL_EARNING_GET_REQUEST:
            return {
                ...state,
                isLoading: true,
                success: false,
                error: false,
            }
        case ActionTypes.PAYROLL_EARNING_GET_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                earning_data: action.payload?.data?.data
            };
        case ActionTypes.PAYROLL_EARNING_GET_ERROR:
            return {
                ...state,
                isLoading: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message
            }
            case ActionTypes.PAYROLL_DEDUCTION_GET_REQUEST:
                return {
                    ...state,
                    isLoading: true,
                    success: false,
                    error: false,
                }
            case ActionTypes.PAYROLL_DEDUCTION_GET_SUCCESS:
                return {
                    ...state,
                    isLoading: false,
                    success: true,
                    successMessage: action.payload?.message,
                    deduction_data: action.payload?.data?.data
                };
            case ActionTypes.PAYROLL_DEDUCTION_GET_ERROR:
                return {
                    ...state,
                    isLoading: false,
                    error: true,
                    success: false,
                    errorMessage: action.payload?.data?.error?.[0]?.message
                }
            case ActionTypes.PAYROLL_CUSTOM_EARNING_GET_REQUEST:
                return {
                    ...state,
                    isEarningsLoading: true,
                    success: false,
                    error: false,
                }
            case ActionTypes.PAYROLL_CUSTOM_EARNING_GET_SUCCESS:
                return {
                    ...state,
                    isEarningsLoading: false,
                    success: true,
                    successMessage: action.payload?.message,
                    custom_earning_data: action.payload?.data?.data
                };
            case ActionTypes.PAYROLL_CUSTOM_EARNING_GET_ERROR:
                return {
                    ...state,
                    isEarningsLoading: false,
                    error: true,
                    success: false,
                    errorMessage: action.payload?.data?.error?.[0]?.message
                }
            case ActionTypes.PAYROLL_CUSTOM_DEDUCTION_GET_REQUEST:
                return {
                    ...state,
                    isDeductionLoading: true,
                    success: false,
                    error: false,
                }
            case ActionTypes.PAYROLL_CUSTOM_DEDUCTION_GET_SUCCESS:
                return {
                    ...state,
                    isDeductionLoading: false,
                    success: true,
                    successMessage: action.payload?.message,
                    custom_deduction_data: action.payload?.data?.data
                };
            case ActionTypes.PAYROLL_CUSTOM_DEDUCTION_GET_ERROR:
                return {
                    ...state,
                    isDeductionLoading: false,
                    error: true,
                    success: false,
                    errorMessage: action.payload?.data?.error?.[0]?.message
                }
        default:
            return state
    }
}